/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * Factory which builds a sort filter that sort string containing number.
 * Ex: "test-10" is after "test-2"
 *
 * @ngInject
 */
function OrderByLocaleCompareFactory($log) {
    const filter = function (data) {
        if (data) {
            data.sort(function (a, b) {
                return a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'});
            });
        }
        return data;
    };

    $log.debug('Factory \'OrderByLocaleCompare\' loaded');
    return filter;
}

export { OrderByLocaleCompareFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/filter/OrderByLocaleCompare.js